import { render, staticRenderFns } from "./ReportsDialog.vue?vue&type=template&id=58c0bb34&scoped=true"
import script from "./ReportsDialog.vue?vue&type=script&lang=js"
export * from "./ReportsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c0bb34",
  null
  
)

export default component.exports